(function () {
  var termlyScriptId = 'termly-jssdk';
  var termlyScriptUrl = 'https://app.termly.io/embed-policy.min.js';

  function loadTermlyPolicy() {
    var placeholder = document.querySelector(
      '[name="termly-embed"][data-id="13a7fe52-6e5d-4889-9d11-813477a61dd2"][data-type="iframe"]'
    );

    if (!placeholder) return;

    var existingScript = document.getElementById(termlyScriptId)
      || document.querySelector('script[src="' + termlyScriptUrl + '"]');

    if (existingScript) return;

    var script = document.createElement('script');
    script.id = termlyScriptId;
    script.src = termlyScriptUrl;
    script.async = true;
    document.head.appendChild(script);
  }

  function initializeCookiePreferences() {
    var control = document.getElementById('cookiePreferencesLink');

    if (!control || control.dataset.cookiePreferencesInitialized === 'true') return;

    control.dataset.cookiePreferencesInitialized = 'true';
    control.addEventListener('click', function () {
      if (
        window.tarteaucitron
        && window.tarteaucitron.userInterface
        && typeof window.tarteaucitron.userInterface.openPanel === 'function'
      ) {
        window.tarteaucitron.userInterface.openPanel();
      }
    });
  }

  function initializePrivacyPolicy() {
    loadTermlyPolicy();
    initializeCookiePreferences();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePrivacyPolicy, { once: true });
  } else {
    initializePrivacyPolicy();
  }
})();
